let url = (new URL(document.URL));
let host = url.hostname
const domain = host.replace('www.', '')

export const baseUrl = 'https://api.'+domain+'/'
export const apiUrl = 'https://api.'+domain+'/api/'
export const SCROLL = 200
export const client_id = 2
export const client_secret = 'WAoRB9R0UYfmvCgKjcbY2R8NmftHwyjdBbfEYwDt'
export const client_afiliado_id = 4
export const client_afiliado_secret = '8NK8eBBxzUCuILkRTrlWEV7APB7aWi5DTaIm7a74'
export const MP_PUBLIC_KEY = 'TEST-3f04e8d7-08c6-426c-ac13-d4beae8eb836'